/**
 * Decode a React Router path/search param.
 *
 * RR7 `matchPath` / `useParams` leave most percent-encoding intact (e.g. `%20`,
 * `%3A`, `%25`) while decoding some values (notably `%2F` → `/`). Always decode
 * once; if the value is already fully decoded, return it unchanged.
 */
export function decodeRouteParam(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

export function decodeOptionalRouteParam(value: string | undefined | null): string | undefined {
  if (value == null) {
    return undefined;
  }
  return decodeRouteParam(value);
}
